module.exports = __webpack_public_path__ + "img/1497476858.80438704.jpg";